import InvestModal from './InvestModal';

export default InvestModal;
